export const STOCK_RETURN_LIST_SUCCESSFULL = "stockReturn_successfull";
export const STOCK_RETURN_LIST = "stockReturn_list";
export const API_ERRORS = 'api_failed';